import * as z from "zod";

import { partnerDetailSchema } from "./shared";

export const getPartner = {
  name: "getPartner" as const,
  input: z.object({ partnerId: z.string() }),
  output: z.object({ partner: partnerDetailSchema }),
};
